import { ROUTES } from '@app/constants/navigation.constants';

export const HERO_ROUTE_PATTERNS = [
  ROUTES.SUCCESS_FEE,
  ROUTES.CANDIDATE_DETAILS,
];

export const ROUTE_TO_BACK_BUTTON_TARGET_MAP = {
  [ROUTES.SUCCESS_FEE]: '/closing',
  [ROUTES.CANDIDATE_DETAILS]: '/interviewing',
};
